type GroupInfoProps = { groups: string[] };

export const GroupInfo = ({ groups }: GroupInfoProps) => {
  if (!groups?.length) {
    return null;
  }

  return (
    <div className="flex items-center">
      <span className="max-w-fit shrink-0">{groups[0]}</span>
      {groups.length > 1 ? (
        <span className="ml-sm basis-md rounded-xs border px-xs text-center text-body-xs leading-5 bg-level-05 border-emphasis-subtle">
          +{groups.length - 1}
        </span>
      ) : null}
      <span className="ml-sm size-sm shrink-0 basis-md rounded-full" />
    </div>
  );
};

GroupInfo.displayName = 'GroupInfo';
